// Texto relativo do "visto por último" da presença.
// Acima de LAST_SEEN_MAX_DAYS o número exato some e vira uma frase fixa:
// "visto 12d atrás" dá a impressão de que a pessoa abandonou o app.

export const LAST_SEEN_MAX_DAYS = 3;
export const LAST_SEEN_FALLBACK = "alguns dias atrás";

export const formatLastSeen = (timestamp, now = Date.now()) => {
  const diffInSeconds = Math.floor((now - new Date(timestamp)) / 1000);
  if (diffInSeconds < 60) return "agora há pouco";
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m atrás`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h atrás`;
  const days = Math.floor(diffInSeconds / 86400);
  if (days > LAST_SEEN_MAX_DAYS) return LAST_SEEN_FALLBACK;
  return `${days}d atrás`;
};
